import { Typography, Grid, Container, Box, Card, CardContent } from "@mui/material";

const FeaturesSection = () => (
    <Container id="features" sx={{ padding: { xs: "4rem 2rem", md: "4rem 0" }, textAlign: "center" }}>
        <Typography variant="h2">KEY FEATURES</Typography>
        <Box display="flex" justifyContent="center" marginBottom={5} marginTop={2.5}>
            <Typography variant="h3" sx={{ fontSize: "30px", fontWeight: "bold", lineHeight: 1.2, width: { xs: '100%', md: '50%' } }}>
                Showcasing Our Expertise: Delivering Excellence Across Our Projects
            </Typography>
        </Box>
        <Grid container spacing={4} justifyContent="center">
            {[
                {
                    title: "Scheduling and Coordination",
                    text: "Expert coordination of subcontractor schedules ensured a seamless workflow.",
                    image: "/img/edit_calendar.svg",
                },
                {
                    title: "Budget Management",
                    text: "Meticulous development and maintenance of the project budget ensured strict adherence to financial compliance.",
                    image: "/img/account_balance_wallet.svg",
                },
                {
                    title: "Quality Control",
                    text: "Rigorous maintenance of quality control measures upheld the high standards expected in luxury construction.",
                    image: "/img/low_density.svg",
                },
                {
                    title: "Regulatory Adherence",
                    text: "All aspects of regulatory compliance were managed to ensure the project met all legal requirements.",
                    image: "/img/contract_edit.svg",
                },
                {
                    title: "Safety Compliance",
                    text: "Strict adherence to safety regulations ensured the creation of a secure working environment in all of our projects.",
                    image: "/img/detector.svg",
                },
                {
                    title: "Customer Satisfaction",
                    text: "Your satisfaction is our top priority. We work closely with you to understand your needs and ensure that the final result aligns with your vision.",
                    image: "/img/for_you.svg",
                },
            ].map((item, index) => (
                <Grid item xs={12} sm={4} key={index}>
                    <Card
                        sx={{
                            border: "1px solid black",
                            borderRadius: "8px",
                            margin: "1rem",
                            padding: "1rem",
                            textAlign: "left",
                            boxShadow: "none",
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            paddingBottom: 0,
                            transition: "all 0.3s ease-in-out",
                            "&:hover": {
                                backgroundColor: "#2A2A2B",
                                color: "white",
                            },
                            "&:hover .icon": {
                                backgroundColor: "#FF7911",
                            },
                        }}
                    >
                        <CardContent>
                            <Box
                                className="icon"
                                sx={{
                                    width: "35px",
                                    height: "35px",
                                    mask: `url(${item.image}) no-repeat center`,
                                    WebkitMask: `url(${item.image}) no-repeat center`,
                                    backgroundColor: "black",
                                    transition: "background-color 0.3s ease-in-out, filter 0.3s ease-in-out",
                                    maskSize: "contain",
                                    WebkitMaskSize: "contain",
                                    maskRepeat: "no-repeat",
                                    WebkitMaskRepeat: "no-repeat",
                                    marginBottom: 3,
                                }}
                            />
                            <Typography variant="h6" marginBottom={2} sx={{ fontSize: "20px", fontWeight: "bold", lineHeight: 1.2 }}>
                                {item.title}
                            </Typography>
                            <Typography variant="body2">{item.text}</Typography>
                        </CardContent>
                    </Card>

                </Grid>
            ))}
        </Grid>
    </Container>
);

export default FeaturesSection;
